// Initial snapshot fetch for the v2 queue.
//
// GET /api/v2/doctors/:mappingId/day?date=YYYY-MM-DD
// -> { status:"SUCCESS", result: { meta, sessions:[...], transferred_in:[...] } }
//
// We reuse the shared axiosInstance so the Bearer token (from UserContext)
// is attached automatically. Passing an absolute URL makes axios ignore its
// v1 baseURL.
import axiosInstance from "../../lib/utils/axiosUtil";
import { baseURLV2 } from "../constants";
import { DaySnapshot } from "../types";

export const getDoctorDaySnapshot = async (
  mappingId: string,
  date: string
): Promise<DaySnapshot> => {
  const res = await axiosInstance.get(
    `${baseURLV2}/doctors/${mappingId}/day`,
    { params: { date } }
  );
  const result = res?.data?.result;
  return {
    meta: result?.meta,
    sessions: Array.isArray(result?.sessions) ? result.sessions : [],
    transferred_in: Array.isArray(result?.transferred_in)
      ? result.transferred_in
      : [],
  };
};
